import { render, staticRenderFns } from "./GateOdol.vue?vue&type=template&id=64959eda&scoped=true&"
import script from "./GateOdol.vue?vue&type=script&lang=js&"
export * from "./GateOdol.vue?vue&type=script&lang=js&"
import style0 from "./GateOdol.vue?vue&type=style&index=0&id=64959eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64959eda",
  null
  
)

export default component.exports